var lorem = {};
module['exports'] = lorem;
lorem.words = require("./words");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ko/lorem/index.js
// module id = 985
// module chunks = 0